import { useEffect, useRef } from 'react';
import { type OrderLoyalty } from '@/shared/api/order';
import { modalsService } from '@/shared/lib/modalsService';
import { getRequestContext } from '@/shared/lib/requestContext';
import { sessionStorageHelper, SessionStorageKey } from '@/shared/lib/sessionStorage';

export const useLoyaltyOnboarding = (loyalty?: OrderLoyalty) => {
    const { account } = getRequestContext();

    const hasProcessedAuthRef = useRef(false);

    useEffect(() => {
        if (hasProcessedAuthRef.current) {
            return;
        }

        const hasPendingAuth = sessionStorageHelper.getItem(SessionStorageKey.LOYALTY_AUTH_PENDING) === '1';

        if (hasPendingAuth && account.loggedIn) {
            hasProcessedAuthRef.current = true;
            sessionStorageHelper.removeItem(SessionStorageKey.LOYALTY_AUTH_PENDING);

            const canRegister = account.loyalty.isEligible && !account.loyalty.isRegistered;
            const orderHasLoyalty = loyalty?.is_registered_user;

            if (canRegister && !orderHasLoyalty) {
                queueMicrotask(() => {
                    modalsService.onLoyaltyRegister('last-step');
                });
            }
        }
    }, [account, loyalty?.is_registered_user]);
};
